import _ from "lodash";

import {
  FileCanvasType,
  FileImageType,
  FileModelType,
  mapAssetsToImagesFiles,
} from "../interfaces";
import { FmFileCanvas, FmFileImage, FmFileModel } from "../interfacesV2";

export function mapFmFileImagesToFileImages(
  files: FmFileImage[]
): FileImageType[] {
  return files.map((file) => ({
    ...file,
    type: "image",
    name: file.meta.metadata.prompt ?? "",
  }));
}

export function mapFileImagesToFmFileImages(
  files: FileImageType[]
): FmFileImage[] {
  return files.map((file) => _.omit(file, ["type", "name"]));
}

export function mapFmFileModelsToFileModels(
  files: FmFileModel[]
): FileModelType[] {
  return files.map((file) => ({
    ...file,
    type: "model",
    width: 512,
    height: 512,
    name: file.meta.name || "Untitled",
    exampleAssets: file.exampleAssets
      ? mapAssetsToImagesFiles(file.exampleAssets)
      : undefined,
  }));
}

export function mapFileModelsToFmFileModels(
  files: FileModelType[]
): FmFileModel[] {
  return files.map((file) => ({
    ..._.omit(file, ["type", "width", "height", "name", "exampleAssets"]),
    exampleAssets: file.exampleAssets?.map((fileAsset) => fileAsset?.meta),
  }));
}

export function mapFmFileCanvasToFileCanvas(
  files: FmFileCanvas[]
): FileCanvasType[] {
  return files.map((file) => ({
    ...file,
    type: "canvas",
    width: 512,
    height: 512,
    name: file.meta.metadata.name || "Untitled",
  }));
}

export function mapFileCanvasToFmFileCanvas(
  files: FileCanvasType[]
): FmFileCanvas[] {
  return files.map((file) => ({
    ..._.omit(file, ["type", "width", "height", "name"]),
  }));
}
